var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"courseware"}},[_c('iframe',{staticClass:"course_frame",attrs:{"src":_vm.frame_root+'/course/list?tbkt_token='+_vm.token,"frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }